import * as React from "react";
const SvgArrowRightBlue = (props) => /* @__PURE__ */ React.createElement("svg", { width: 7, height: 12, viewBox: "0 0 7 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1.5 2L5.5 6L1.5 10", stroke: "#0057B8", strokeWidth: 1.5, strokeLinecap: "square" }));
export default SvgArrowRightBlue;
